import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

import * as utils from '../utils/duckHelpers';

export const types = {
    ...utils.requestTypes('IMPACTING_POLICIES'),
    IMPACTING_POLICIES_RESET: 'IMPACTING_POLICIES_RESET',
    IMPACTING_POLICIES_SET: 'IMPACTING_POLICIES_SET',
    IMPACTING_POLICIES_GET: 'IMPACTING_POLICIES_GET',
    IMPACTING_POLICIES_SUCCESS: 'IMPACTING_POLICIES_SUCCESS',
};

export const actions = {
     
    impacting_policiesSet: (obj) => utils.action(types.IMPACTING_POLICIES_SET, obj),
};

const initialState = fromJS({
    loaded: 'loading',
    impacting_policies: [],
    page: 0,
    total: 0,
});

export default (state = initialState, action) => {
    switch (action.type) {
    case types.IMPACTING_POLICIES_GET:
        return state.merge({
            loaded: 'loading',
        });
    case types.IMPACTING_POLICIES_SET:
        if (action.payload.impacting_policies) {
            return state.merge({
                loaded: 'complete',
                impacting_policies: action.payload.impacting_policies,
                total: action.payload.total,
                page: action.payload.page,
            });
        }

        return state.merge({
            loaded: 'empty',
            page: 0,
            impacting_policies: [],
            total: 0,
        });

    case types.IMPACTING_POLICIES_RESET:
        return initialState;

    default:
        return state;
    }
};

const getImpactingPolicies = (state) => state.get('app').get('impactingPolicies');

export const selectors = {
    getImpactingPolicies: getImpactingPolicies,
};
